import { gql } from '@apollo/client';
const GET_SPECIFICATION_COMPONENT_VARIANTS = gql `
  query GetSpecificationComponentVariants($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        components {
          edges {
            node {
              id
              name
              hasOneVariantColorForAllSpecificationColors
              hasOneVariantSizeForAllSpecificationSizes
              variantColorForAllSpecificationColors
              variantSizeForAllSpecificationSizes
              productSnapshot {
                id
                variantSnapshots {
                  edges {
                    node {
                      id
                      color
                      size
                    }
                  }
                }
              }
              colors {
                edges {
                  node {
                    id
                    modelSpecificationColor {
                      id
                      name
                    }
                    productVariantColor
                  }
                }
              }
              sizes {
                edges {
                  node {
                    id
                    modelSpecificationSize {
                      id
                      sizeName {
                        id
                        name
                      }
                    }
                    productVariantSize
                  }
                }
              }
              productCategory {
                id
                type
                typeLabelPL
                typeLabelEN
                typeIcon
                variantHasSize
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_COMPONENT_VARIANTS;
